import { css, makeStyles } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  containerWrapper: css`
    display: flex;
    flex-direction: column;
  `,

  divisorLine: css`
    margin-bottom: 0;
  `,
  container: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,

  avatarWrapper: theme => css`
    display: flex;
    padding-top: ${theme.spacing.xxs};
    div {
      display: flex;
      flex-direction: column;
    }
  `,

  textWrapper: theme => css`
    padding-left: ${theme.spacing.xxs};
    span {
      line-height: ${theme.spacing.xs};
      font-size: ${theme.fontSizes.xs};
    }
  `,
})

export { useStyles }
